(function () {
    'ngInject';

    angular.module('app.shared.services').factory('AppCuesService', appCuesService);

    function appCuesService($location) {
        var currentFlow = '';
        var WelcomeFlowCPart1 = '2cdc5760-a3a7-4d46-b390-1b44eaaa03de';
        var WelcomeFlowCPart2 = 'd07d37ff-e2e7-4c9f-abb3-ed1a45ca2372';
        var OptionBPart1 = 'a690af32-cbb3-45f9-84aa-8f89b4fadcaf';
        var OptionBPart2 = 'd1636f07-dfb2-49d8-8816-3b2c720e21c1';
        var OptionBPart3 = 'b5f43204-3ed4-4fbe-ad7a-e43edb3c005f';
        var OptionBPart4 = 'bfd78df9-76c1-4bae-9dc6-8eb692171b36';
        var OptionBPart5 = '2debb064-3da6-4b64-9e74-397614d33ea4';
        var OptionBPart6 = 'd3b5da1e-4ba2-41eb-a61d-0d40bd320044';
        var OptionBPart7 = '544b7a0a-03fa-4830-bb12-2c5608213508';
        var OptionBPart8 = 'ca7152cb-5540-445d-9925-81176df17be6';
        var OptionBPart9 = '908eba7e-9f8b-4f67-b292-1054041298bc';
        var OptionBPart10 = '1b7f49df-9bd1-493d-8f6e-b5e31725e982';
        var OptionBPart11 = 'bff737c7-c6be-4896-a80c-b5ef6899a69b';

        var typingTimer; //timer identifier
        var doneTypingInterval = 2000; //time in ms (2 seconds)

        function proceedAfterDoneTyping() {
            if ($location.$$path == '/createProduct3') {
                clearTimeout(typingTimer);
                typingTimer = setTimeout(doneTyping, doneTypingInterval);

                function doneTyping() {
                    if (getCurrentFlow() == OptionBPart10) {
                        window.Appcues?.show(OptionBPart11);
                    }
                }
            }
        }

        function WelcomeFlowCPart1() {
            return WelcomeFlowCPart1;
        }

        function WelcomeFlowCPart2() {
            return WelcomeFlowCPart2;
        }

        function OptionBPart1() {
            return OptionBPart1;
        }

        function OptionBPart2() {
            return OptionBPart2;
        }

        function OptionBPart3() {
            return OptionBPart3;
        }

        function OptionBPart4() {
            return OptionBPart4;
        }

        function OptionBPart5() {
            return OptionBPart5;
        }

        function OptionBPart6() {
            return OptionBPart6;
        }

        function OptionBPart7() {
            return OptionBPart7;
        }

        function OptionBPart8() {
            return OptionBPart8;
        }

        function OptionBPart9() {
            return OptionBPart9;
        }

        function OptionBPart10() {
            return OptionBPart10;
        }

        function setCurrentFlow(CurrentFlow) {
            currentFlow = CurrentFlow;
        }

        function getCurrentFlow() {
            return currentFlow;
        }

        return {
            setCurrentFlow: setCurrentFlow,
            getCurrentFlow: getCurrentFlow,
            WelcomeFlowCPart1: WelcomeFlowCPart1,
            WelcomeFlowCPart2: WelcomeFlowCPart2,
            OptionBPart1: OptionBPart1,
            OptionBPart2: OptionBPart2,
            OptionBPart3: OptionBPart3,
            OptionBPart4: OptionBPart4,
            OptionBPart5: OptionBPart5,
            OptionBPart6: OptionBPart6,
            OptionBPart7: OptionBPart7,
            OptionBPart8: OptionBPart8,
            OptionBPart9: OptionBPart9,
            OptionBPart10: OptionBPart10,
            proceedAfterDoneTyping: proceedAfterDoneTyping
        };
    }
})();
